module.exports = __webpack_public_path__ + "img/gerb.6a588efe.png";